import { render, staticRenderFns } from "./PreviewFormTable.vue?vue&type=template&id=6bfad2d3&"
import script from "./PreviewFormTable.vue?vue&type=script&lang=js&"
export * from "./PreviewFormTable.vue?vue&type=script&lang=js&"
import style0 from "./PreviewFormTable.vue?vue&type=style&index=0&id=6bfad2d3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports